import { Object3D } from "three";
import { TypedNode } from "../_Base";
import { NodeContext } from "../../poly/NodeContext";
import { Group } from "three";
const INPUT_OBJECT_NAME = "parent object";
const DEFAULT_INPUT_NAMES = [INPUT_OBJECT_NAME, INPUT_OBJECT_NAME, INPUT_OBJECT_NAME, INPUT_OBJECT_NAME];
export var ObjNodeRenderOrder = /* @__PURE__ */ ((ObjNodeRenderOrder2) => {
  ObjNodeRenderOrder2[ObjNodeRenderOrder2["MANAGER"] = 0] = "MANAGER";
  ObjNodeRenderOrder2[ObjNodeRenderOrder2["CAMERA"] = 2] = "CAMERA";
  ObjNodeRenderOrder2[ObjNodeRenderOrder2["LIGHT"] = 3] = "LIGHT";
  return ObjNodeRenderOrder2;
})(ObjNodeRenderOrder || {});
export class TypedObjNode extends TypedNode {
  constructor() {
    super(...arguments);
    this.renderOrder = 0 /* MANAGER */;
    this._children_group = this._create_children_group();
    this._attachableToHierarchy = true;
    this._used_in_scene = true;
  }
  static context() {
    return NodeContext.OBJ;
  }
  static displayedInputNames() {
    return DEFAULT_INPUT_NAMES;
  }
  _create_children_group() {
    const group = new Group();
    group.matrixAutoUpdate = false;
    return group;
  }
  attachableToHierarchy() {
    return this._attachableToHierarchy;
  }
  usedInScene() {
    return this._used_in_scene;
  }
  addObjectToParent(parent) {
    if (this.attachableToHierarchy()) {
      parent.add(this.object);
    }
  }
  removeObjectFromParent() {
    if (this.attachableToHierarchy()) {
      const parent = this.object.parent;
      if (parent) {
        parent.remove(this.object);
      }
    }
  }
  initializeBaseNode() {
    this._object = this._create_object_with_attributes();
    this.nameController.add_post_set_fullPath_hook(this.set_object_name.bind(this));
    this.set_object_name();
  }
  childrenGroup() {
    return this._children_group;
  }
  get object() {
    return this._object;
  }
  _create_object_with_attributes() {
    const object = this.createObject();
    object.node = this;
    object.add(this._children_group);
    return object;
  }
  set_object_name() {
    if (this._object) {
      this._object.name = this.path();
      this._children_group.name = `${this.path()}:parentedOutputs`;
    }
  }
  createObject() {
    const object = new Object3D();
    object.matrixAutoUpdate = false;
    return object;
  }
  isDisplayNodeCooking() {
    if (this.displayNodeController) {
      const displayNode = this.displayNodeController.displayNode();
      if (displayNode) {
        return displayNode.cookController.isCooking();
      }
    }
    return false;
  }
  isDisplayed() {
    var _a, _b;
    return ((_b = (_a = this.flags) == null ? void 0 : _a.display) == null ? void 0 : _b.active()) || false;
  }
}
export class BaseObjNodeClass extends TypedObjNode {
}
